import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";

// Section heading in the customise dialog. Called bare for the variation list,
// and with the addon's own title/description/status for each addon — the
// props used to be ignored, so every addon read "Select Variation".
function ItemHeadingView({ title, subTitle, status, error = false }) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Typography
          style={{ fontSize: "1.25rem" }}
          className={classes.itemTitle}
        >
          {title ?? t("selectVariation")}
        </Typography>
        <Box>
          <Typography
            className={clsx(classes.infoStyle, { [classes.itemError]: error })}
          >
            {status ?? t("required")}
          </Typography>
        </Box>
      </Box>
      {(subTitle ?? t("subTitle")) ? (
        <Box>
          <Typography className={classes.priceTitle}>
            {subTitle ?? t("subTitle")}
          </Typography>
        </Box>
      ) : null}
    </>
  );
}

export default React.memo(ItemHeadingView);
